import type { FunctionComponent } from 'react'
import { GridWithGaps } from '../layout/MainGrid'
import { useNewsletterForm } from './useNewsletterForm'

const StyledNewsletterForm = ({ children }: { children: React.ReactNode }) => (
  <div className="col-span-full">{children}</div>
)
const StyledEmailField = ({ children }: { children: React.ReactNode }) => (
  <div
    aria-label="E-Mail"
    className="col-span-full md:col-span-8 ml:col-span-6"
  >
    {children}
  </div>
)
const StyledLegalImprintField = ({
  children,
}: {
  children: React.ReactNode
}) => <div className="col-span-full mt-px-32 ml:col-span-8">{children}</div>
const StyledSubmitButton = ({ children }: { children: React.ReactNode }) => (
  <div className="col-span-full mt-px-32">{children}</div>
)

export const NewsletterForm: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const {
    EmailField,
    LegalImprintField,
    SubmitButton,
    FormProvider,
    formProps,
    formProviderProps,
    SuccessDialog,
  } = useNewsletterForm()
  return (
    <StyledNewsletterForm>
      <FormProvider {...formProviderProps}>
        <form {...formProps}>
          <GridWithGaps>
            <StyledEmailField>{EmailField}</StyledEmailField>
            <StyledLegalImprintField>
              {LegalImprintField}
            </StyledLegalImprintField>
            <StyledSubmitButton>{SubmitButton}</StyledSubmitButton>
          </GridWithGaps>
        </form>
      </FormProvider>
      {SuccessDialog}
    </StyledNewsletterForm>
  )
}
